











































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import { accountSettingsService } from '@/services/AccountSettingsService';
import SshKeys from '@/components/account-settings/SshKeys.vue';
import TwoFA from '@/components/account-settings/TwoFA.vue';
import { format } from 'date-fns';
import EventBus from '@/EventBus';
import { tokenService } from '@/services/TokenService';
import { localeService } from '../../services/LocaleService';
import ActiveSessions from '@/components/account-settings/ActiveSessions.vue';

@Component({
  components: {
    Header,
    SshKeys,
    TwoFA,
    ActiveSessions,
  },
})
export default class AccountSettings extends Vue {
  isEditingUserNameHidden = true;
  isEditingEmailHidden = true;
  isEditingPassHidden = true;
  isUserNameEmpty = false;
  accountSettings: any = {};
  orginalName = '';
  orginalEmail = '';
  errors: any = [];
  mailErrors: any = [];
  notRemovedWorkspace: boolean = false;
  password = '';
  isModalShown: boolean = false;
  language = '';
  isLoading: boolean = false;
  oldPass = '';
  newPass = '';
  repeatPass = '';
  isInvalidCurrentPass: boolean = false;
  isActiveOldPassValidation: boolean = false;
  isActiveNewPassValidation: boolean = false;
  isActivePassRepeatValidation: boolean = false;
  isPassChangeSuccessfulDialog: boolean = false;

  formatDate(date: string) {
    return date ? format(new Date(date), 'dd.MM.yyyy') : '';
  }

  onClose() {
    this.isModalShown = false;
  }

  logout() {
    tokenService.removeToken();
    this.$router.push('/login').catch(() => {});
  }

  changeLang(lang: string) {
    const isAuth = !!tokenService.getToken();
    this.$root.$i18n.locale = lang;
    if (isAuth) {
      localeService.setLocale(lang);
    }
  }

  isWeakPassword() {
    let strength = 0;
    if (/[a-z]+/.test(this.password)) {
      strength += 1;
    }
    if (/[A-Z]+/.test(this.password)) {
      strength += 1;
    }
    if (/[!@#$%^&*(){}.,_=+\-<>;:]/.test(this.password)) {
      strength += 1;
    }
    if (/[0-9]+/.test(this.password)) {
      strength += 1;
    }
    return strength < 3 && this.password;
  }

  mounted() {
    this.getSettings();
  }

  cancelName() {
    this.isEditingUserNameHidden = !this.isEditingUserNameHidden;
    this.accountSettings.name = this.orginalName;
    this.isUserNameEmpty = false;
  }

  cancelEmail() {
    this.isEditingEmailHidden = !this.isEditingEmailHidden;
    this.accountSettings.email = this.orginalEmail;
    this.mailErrors = [];
  }

  getSettings() {
    accountSettingsService
      .getSettings()
      .then((data: any) => {
        this.accountSettings = data;
        this.orginalName = data.name;
        this.orginalEmail = data.email;
        this.language = data.locale;
      })
      .catch(() => {});
  }

  updateAccountName() {
    if (this.accountSettings.name === '') {
      this.isUserNameEmpty = true;
    } else {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      accountSettingsService
        .updateAccountName({
          name: this.accountSettings.name,
        })
        .then(() => {
          this.isLoading = false;
          this.isEditingUserNameHidden = true;
          this.orginalName = this.accountSettings.name;
          EventBus.$emit('user-name-changed', this.accountSettings.name);
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }

  updateEmail() {
    this.mailErrors = [];
    if (this.accountSettings.email === '') {
      this.mailErrors.push(this.$t('validation.fieldIsRequired'));
    }
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
        this.accountSettings.email
      ) &&
      this.accountSettings.email
    ) {
      this.mailErrors.push(this.$t('validation.wrongEmailFormat'));
    }
    if (this.mailErrors.length > 0) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    accountSettingsService
      .updateEmail({
        email: this.accountSettings.email,
      })
      .then(() => {
        this.isLoading = false;
        this.isEditingEmailHidden = true;
        this.getSettings();
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data.status === 422) {
          if (data.data && data.data.error && data.data.error.email[0].error === 'blacklisted') {
            this.mailErrors.push(this.$t('error.email.blacklisted'));
          } else {
            this.mailErrors.push(this.$t('validation.emailAlreadyInUse'));
          }
        }
      });
  }

  updatePassword() {
    this.isActiveOldPassValidation = true;
    this.isActiveNewPassValidation = true;
    this.isActivePassRepeatValidation = true;

    if (!this.oldPass || !this.newPass || this.newPass !== this.repeatPass || this.isLoading) {
      return;
    }
    this.isLoading = true;
    accountSettingsService
      .updatePassword({
        current_password: this.oldPass,
        password: this.newPass,
        password_confirmation: this.repeatPass,
      })
      .then(() => {
        this.isLoading = false;
        this.isEditingPassHidden = true;
        this.isPassChangeSuccessfulDialog = true;
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data.status === 422) {
          if (data && data.data && data.status === 422) {
            let error = data.data.error || {};
            if (error.current_password && error.current_password[0] && error.current_password[0].error === 'invalid') {
              this.isInvalidCurrentPass = true;
            }
          }
        }
      });
  }

  deleteAccount() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    accountSettingsService
      .deleteAccount()
      .then(() => {
        this.isLoading = false;
        tokenService.removeToken();
        this.$router
          .push({
            path: '/registration',
            query: { redirect: this.$route.fullPath },
          })
          .catch(() => {});
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data.status === 403) {
          if (data.data && data.data.error) {
            this.notRemovedWorkspace = true;
          }
        }
      });
  }
}
